module.exports = __webpack_public_path__ + "pinduTitle.39f157a0.png";